import { handleResponseOld, makePost } from './helpers';

/**
 * @category Item API
 * @see fetchBidIncrements
 */
type FetchBidIncrementsParams = {
    catalogId: number;
    deployment: string;
};

/**
 * POST request to item-api service that sends a set of catalog IDs and returns bid increment data for all catalogs
 * @function fetchBidIncrements
 * @category Item API
 * @param {FetchBidIncrementsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/bid-increments
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/bidding/routes/post-bid-increments-old.ts
 */
export const fetchBidIncrements = ({ catalogId, deployment }: FetchBidIncrementsParams) =>
    new Promise<any>((resolve, reject) => {
        const request = makePost({ deployment, path: '<ITEM-API>spa/small/bid-increments' });
        request.send({ catalogIds: [catalogId] });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });
